import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { displayError } from "../utils/error-handling";

export interface CompanyStatus {
  id: number;
  status: string;
}

const fetchCompanyStatusList = async (authHeader: string) => {
  return axios.get<CompanyStatus[]>(
    `${env.verifyServiceUrl}common/company_status_list/`,
    {
      headers: { Authorization: authHeader },
      skipGlobalErrorHandler: true,
    },
  );
};

export const useCompanyStatusList = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["companyStatusList"],
    queryFn: () => fetchCompanyStatusList(authHeader),
    retry: false,
    select: (response) => response.data,
    onError: (err: any) => {
      const status = err?.response?.status ?? err?.request?.status;

      const message =
        err?.response?.data?.detail || "Failed to load company status list.";

      if (status === 500 || status === 503) {
        displayError(message);
      }

      if (status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
